// // import React from "react";
// // import Particles from "react-tsparticles";

// // function Particle() {
// //     return (
// //     <Particles
// //       id="bubbles"
// //       params={{
// //         particles: {
// //           number: {
// //             value: 60,
// //             density: {
// //               enable: true,
// //               value_area: 800,
// //             },
// //           },
// //           color: {
// //             value: "#00bfff",
// //           },
// //           shape: {
// //             type: "circle",
// //           },
// //           opacity: {
// //             value: 0.3,
// //             random: true,
// //           },
// //           size: {
// //             value: 10,
// //             random: true,
// //           },
// //           move: {
// //             direction: "top",
// //             speed: 1,
// //             out_mode: "out",
// //           },
// //         },
// //         interactivity: {
// //           events: {
// //             onhover: {
// //               enable: true,
// //               mode: "bubble",
// //             },
// //             onclick: {
// //               enable: true,
// //               mode: "repulse",
// //             },
// //           },
// //           modes: {
// //             bubble: {
// //               distance: 150,
// //               size: 12,
// //               duration: 2,
// //               opacity: 0.6,
// //               speed: 3,
// //             },
// //             repulse: {
// //               distance: 200,
// //               duration: 0.4,
// //             },
// //           },
// //         },
// //         retina_detect: true,
// //       }}
// //     />
// //   );
// // }

// // export default Particle;

// import React from "react";
// import Particles from "react-tsparticles";

// function Particle() {
//   return (
//     <Particles
//       id="bubbles"
//       params={{
//         particles: {
//           number: {
//             value: 60,
//             density: {
//               enable: true,
//               value_area: 800,
//             },
//           },
//           color: {
//             value: "#6a1b9a",
//           },
//           shape: {
//             type: "circle",
//           },
//           opacity: {
//             value: 0.3,
//             random: true,
//           },
//           size: {
//             value: 10,
//             random: true,
//           },
//           move: {
//             direction: "top",
//             speed: 1,
//             out_mode: "out",
//           },
//         },
//         interactivity: {
//           events: {
//             onhover: {
//               enable: true,
//               mode: "bubble",
//             },
//             onclick: {
//               enable: true,
//               mode: "repulse",
//             },
//           },
//           modes: {
//             bubble: {
//               distance: 150,
//               size: 12,
//               duration: 2,
//               opacity: 0.6,
//               speed: 3,
//             },
//             repulse: {
//               distance: 200,
//               duration: 0.4,
//             },
//           },
//         },
//         retina_detect: true,
//       }}
//     />
//   );
// }

// export default Particle;
import React, { useEffect, useState } from "react";
import Particles from "react-tsparticles";

function Particle() {

  return (
    <div>
      <Particles
        id="constellation"
        options={{
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                area: 1000,
              },
            },
            color: {
              value: "#E55812",
            },
            shape: {
              type: "circle",
            },
            opacity: {
              value: 0.5,
              random: false,
            },
            size: {
              value: 3,
              random: true,
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: "#ffffff",
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 1.2,
              direction: "none",
              random: false,
              straight: false,
              outMode: "out",
              bounce: false,
            },
          },
          interactivity: {
            detectsOn: "canvas",
            events: {
              onHover: {
                enable: true,
                mode: "grab",
              },
              onClick: {
                enable: true,
                mode: "push",
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 200,
                line_linked: {
                  opacity: 0.6,
                },
              },
              push: {
                particles_nb: 4,
              },
            },
          },
          retina_detect: true,
          background: {
            color: "transparent",
          },
        }}
      />
    </div>
  );
}

export default Particle;
